import { Component } from '@angular/core';

@Component({
    standalone: true,
    selector: 'app-footer',
    templateUrl: './app.footer.html'
})
export class AppFooter {}
